module.exports = __webpack_public_path__ + "img/bgtop-anli.0742ec04.jpg";